import React from "react";
import { Card, CardContainer } from "../../../../components/Card";
import {
    BarChart,
    LineChart,
    StackedBarChart,
} from "../../../../components/Charts";

const Affiliate = ({ data }) => {
    // Filter data to only include entries with autopay and manual_payment values
    const paymentData = data.filter(
        (item) => item.autopay !== null && item.manual_payment !== null
    );

    return (
        <>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Total number of Impressions",
                            key: "total_impressions",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="Total Impressions"
                />
            </CardContainer>

            {/* New StackedBarChart for Autopay and Manual Payment */}
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Total Paid",
                            key: "total_paid",
                        },
                    ]}
                    xKey="week"
                    title="Total Payment"
                />
            </CardContainer>

            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Total Live Assets",
                            key: "total_live_assets",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="Total Live Assets"
                />
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Total Sales",
                            key: "total_sales",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="Total Sales"
                />
            </CardContainer>
            <CardContainer>
                <BarChart
                    data={data}
                    series={[
                        {
                            name: "Total Creators",
                            key: "total_creators",
                        },
                        {
                            name: "Active Creators",
                            key: "total_active_creators",
                        },
                    ]}
                    xKey="week"
                    title="Total vs Active Creators Stats"
                    yOverlap={[
                        {
                            name: "Total Creators",
                        },
                        {
                            name: "Active Creators",
                            opposite: true,
                        },
                    ]}
                />
                <BarChart
                    data={data}
                    series={[
                        {
                            name: "Total Engagements",
                            key: "total_engagements",
                        },
                        {
                            name: "Total Traffic",
                            key: "total_traffic",
                        },
                    ]}
                    xKey="week"
                    title="Engagement vs Traffic Stats"
                    yOverlap={[
                        {
                            name: "Total Engagements",
                        },
                        {
                            name: "Total Traffic",
                            opposite: true,
                        },
                    ]}
                />
            </CardContainer>
            <CardContainer>
                <LineChart
                    data={data}
                    series={[
                        {
                            name: "Total Active Creators",
                            key: "total_active_creators",
                        },
                        {
                            name: "Total Revenue Generating Creators",
                            key: "total_revenue_generating_creators",
                        },
                    ]}
                    xKey="week"
                    // yLabel="Seats Sold"
                    title="Total Active / Revenue Generating Creators"
                />
            </CardContainer>
            <CardContainer>
                <StackedBarChart
                    data={data}
                    series={[
                        {
                            name: "Autopay",
                            key: "autopay",
                        },
                        {
                            name: "Manual Payment",
                            key: "manual_payment",
                        },
                    ]}
                    xKey="week"
                    title="Payment Distribution"
                    isCategoryX={true}
                    yLabel="Amount"
                />
            </CardContainer>
        </>
    );
};

export default Affiliate;
